<template>
  <div>
    <LoadingOverlay :loading="loading" />
    <div class="agencyCentre-wrapper">
      <div class="agencyCentre-topSec" :style="{ backgroundImage: `url(${agnecyCenterBg})` }">
        <div class="position-relative items-center agencyCentre-headerBar text-white">
          <div class="angle" id="close" @click="viewClose('someStatus')"></div>
          <div class="text-center agencyCentre-headerHD">Agency Centre</div>
          <div class="d-flex justify-content-center align-items-center text-center agencyCentre-dropdown"
            @click="goToAgencyTeamList">My Hosts</div>
        </div>
        <div class="text-center text-white agencyCentre-topContentBox">
          <div class="mb-1">
            <img :src="invite_yourFrientTextImage" alt="invite" />
          </div>
          <p class="agencyCentre-topTitle mb-0">अपने दोस्त को होस्ट बनने का मौका दें!</p>
          <div class="agencyCentre-gapBG"></div>

          <div class="d-flex justify-content-center align-items-center gap-1 agencyCentre-IDBox" @click="copyAgencyId">
            <span>Agency ID :</span>
            <span>{{ agencyData?.agency_profile_id || '-' }}</span>
            <img :src="copyIdIcon" class="copyIcon" title="Copy ID" alt="Copy ID" />
          </div>

          <div class="cursor-pointer text-center text-white inviteYourFriend-buttonBox">
            <div class="inviteYourFriend-button" @click="sendInvite"
              :style="{ backgroundImage: `url(${invite_yourFrientBtnBg})` }">Invite Your Friend</div>
          </div>
        </div>

        <div class="agencyIncome-cardWrapper">
          <div class="agencyIncome-card">
            <div class="d-flex justify-content-between align-items-center agencyIncome-cardHeader">
              <div class="d-flex justify-content-center align-items-center gap-1 fw-semibold agencyIncome-card-title">
                Agency Income :
                <span class="agency-totalIncome">
                  ${{ money(agencyData?.agency_total_commission) }}
                </span>
              </div>
              <div class="position-relative agencyIncome-card-dropdown acretIcon" @click="openDateModal">
                {{ selectedWeek }}
              </div>
            </div>

            <div class="agencyIncome-cardBody">
              <div class="d-flex justify-content-between agencyIncome-cardBoxes">
                <div class="position-relative text-center agencyIncome-cardBox">
                  <div class="agencyIncome-cardBox-title">Host Income</div>
                  <h3 class="fw-semibold agencyIncome-cardBox-val">${{ money(agencyData?.agency_host_income) }}</h3>
                </div>
                <div class="position-relative text-center agencyIncome-cardBox">
                  <div class="agencyIncome-cardBox-title">My Commission</div>
                  <h3 class="fw-semibold agencyIncome-cardBox-val">{{ agencyData?.agency_host_commission_ratio ?? 0 }}%
                  </h3>
                </div>
                <div class="position-relative text-center agencyIncome-cardBox">
                  <div class="agencyIncome-cardBox-title">My Income</div>
                  <h3 class="fw-semibold agencyIncome-cardBox-val">${{ money(agencyData?.agency_host_commsion_amount) }}
                  </h3>
                </div>
              </div>

              <div class="box_divide_line"></div>

              <!-- <div class="d-flex justify-content-between agencyIncome-cardBoxes subAgency-cardBoxes">
                <div class="position-relative text-center agencyIncome-cardBox">
                  <div class="agencyIncome-cardBox-title">Sub Agency</div>
                  <h3 class="fw-semibold agencyIncome-cardBox-val">${{ money(agencyData?.agency_sub_agency_income) }}
                  </h3>
                </div>
                <div class="position-relative text-center agencyIncome-cardBox">
                  <div class="agencyIncome-cardBox-title">Commission</div>
                  <h3 class="fw-semibold agencyIncome-cardBox-val">{{ agencyData?.agency_sub_agency_commission_ratio ??
                    0 }}%</h3>
                </div>
                <div class="position-relative text-center agencyIncome-cardBox">
                  <div class="agencyIncome-cardBox-title">Agency Income</div>
                  <h3 class="fw-semibold agencyIncome-cardBox-val">${{
                    money(agencyData?.agency_sub_agency_commission_amount) }}</h3>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div><!-- /topSec -->

      <div class="agencyIncome-cardWrapper hostCard-listWrapper mt-3">
        <div class="agencyIncome-card">
          <div class="d-flex justify-content-between align-items-center agencyIncome-cardHeader">
            <div class="fw-semibold agencyIncome-card-title">Anchor Income Details</div>
            <div class="agencyIncome-card-title">
              <span class="agency-totalIncome">${{ money(agencyData?.agency_host_income) }}</span>
            </div>
          </div>

          <div class="agencyIncome-cardBody">
            <div class="hostCard-boxWrap" v-for="agencyHostInfo in agencyHostData"
              :key="agencyHostInfo?.user_id || agencyHostInfo?.id">
              <div class="d-flex justify-content-between align-items-center hostCard-topBoxes">
                <div class="d-flex align-items-center hostCard-leftBox">
                  <div class="d-flex align-items-center hostCard-imageBox">
                    <img
                      :src="agencyHostInfo?.profile_image && agencyHostInfo.profile_image.length ? agencyHostInfo.profile_image : defaultProfile"
                      alt="host profile image" @error="onImageError" />
                  </div>
                  <div class="hostCard-infoBox">
                    <div class="hostCard-name">{{ agencyHostInfo?.name || '-' }}</div>
                    <div class="hostCard-ID">ID: {{ agencyHostInfo?.profile_id || '-' }}</div>
                  </div>
                </div>

                <div class="d-flex align-items-center gap-2 hostCard-rightBox"
                  @click="goToTeamIncomeOverview(agencyHostInfo.user_id)">
                  <div>${{ money(agencyHostInfo?.payout_dollar) }}</div>
                  <img :src="blackNextArrow" class="blackNextArrow" alt=">" />
                </div>
              </div>

              <div class="d-flex justify-content-between agencyIncome-cardBoxes">
                <div class="position-relative text-center agencyIncome-cardBox">
                  <div class="agencyIncome-cardBox-title">Total Income</div>
                  <h3 class="d-flex justify-content-center align-items-center gap-1 agencyIncome-cardBox-val">
                    <img :src="beansIcon" class="beansIcon" alt="" />
                    <div>{{ agencyHostInfo?.total_coins_earned ?? 0 }}</div>
                  </h3>
                </div>
                <div class="position-relative text-center agencyIncome-cardBox">
                  <div class="agencyIncome-cardBox-title">Call Income</div>
                  <h3 class="d-flex justify-content-center align-items-center gap-1 agencyIncome-cardBox-val">
                    <img :src="beansIcon" class="beansIcon" alt="" />
                    <div>{{ agencyHostInfo?.total_call_coins ?? 0 }}</div>
                  </h3>
                </div>
                <div class="position-relative text-center agencyIncome-cardBox">
                  <div class="agencyIncome-cardBox-title">Gifts Income</div>
                  <h3 class="d-flex justify-content-center align-items-center gap-1 agencyIncome-cardBox-val">
                    <img :src="beansIcon" class="beansIcon" alt="" />
                    <div>{{ agencyHostInfo?.total_gift_coins ?? 0 }}</div>
                  </h3>
                </div>
              </div>
            </div><!-- /host card -->
          </div>
        </div>
      </div>

      <!-- Weekly Date popup -->
      <div class="dateSelectionModal" :style="showModal ? { bottom: '0' } : {}" v-if="showModal" @click="closeModal">
        <div class="dateSelectionModal-body" :style="{ bottom: '0' }" @click.stop>
          <div class="text-center dateSelection-HD">Select Date Range</div>
          <ul class="dateOptions-list">
            <li class="d-flex justify-content-center align-items-center gap-2 dateOptions-box"
              v-for="(range, index) in dateRanges" :key="index" @click="selectDate(range)">
              <div class="numberOf-week">{{ range.week_data }}</div>
              <div class="dateOptions">{{ range.start_date }}</div>
              <div class="dateOptions-to">to</div>
              <div class="dateOptions">{{ range.end_date }}</div>
            </li>
          </ul>
        </div>
      </div>

      <!-- copy id -->
      <div v-if="showCopyPopup" class="copy-popup">Agency ID Copied</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import './AgencyCentreStyle.css';
import agnecyCenterBg from '../../assets/images/agency-centre/invite_subAgent_Bg.webp';
import invite_yourFrientTextImage from '../../assets/images/agency-centre/invite_your_frient_textImage.webp';
import invite_yourFrientBtnBg from '../../assets/images/agency-centre/inviteFriend_btnBg.webp';
import defaultProfile from '../../assets/images/default_profile.webp';
import blackNextArrow from '../../assets/images/agency-centre/black-nextarrow.svg';
import copyIdIcon from '../../assets/images/agency-centre/copy_Id_icon.svg';
import beansIcon from '../../assets/images/beansIcon.png';

import LoadingOverlay from '../LoadingOverlay.vue';

// Use zeep.live as base (or allow override via env)
const API_BASE =
  (import.meta?.env?.VITE_API_BASE_URL) ||
  (typeof process !== 'undefined' && process.env?.VUE_APP_API_BASE_URL) ||
  'https://starmate.co.in/api';

const api = axios.create({ baseURL: API_BASE });

export default {
  name: 'AgencyCentre',
  components: { LoadingOverlay },
  data() {
    return {
      agencyData: {},
      agencyHostData: [],
      dateRanges: [],
      selectedWeek: 'This Week',
      startDate: '',
      endDate: '',
      agnecyCenterBg,
      invite_yourFrientTextImage,
      invite_yourFrientBtnBg,
      defaultProfile,
      blackNextArrow,
      copyIdIcon,
      beansIcon,
      showModal: false,
      loading: false,
      showCopyPopup: false,
      authToken: ''
    };
  },
  async mounted() {
    // token from /agency-centre/token=<JWT> (param or query)
    const rawParam = this.$route.params.token || this.$route.query.token || '';
    this.authToken = this.normalizeToken(rawParam);

    if (!this.authToken) {
      console.error('Token missing in URL. Expected /agency-centre/token=<JWT> or ?token=<JWT>');
      return;
    }

    // Add Bearer for all requests
    api.defaults.headers.common['Authorization'] = `Bearer ${this.authToken}`;

    // (optional) debug log final URLs
    api.interceptors.request.use((cfg) => {
      try {
        new URL((cfg.baseURL || '') + '/' + (cfg.url || ''));
        // const full = new URL((cfg.baseURL || '') + '/' + (cfg.url || ''));
        // console.log('[API] →', cfg.method?.toUpperCase(), full.toString());
      } catch (_) {
        // ignore URL parse errors
      }
      return cfg;
    });

    await this.fetchDateRangesAndThenAgencyData();
  },
  methods: {
    // redirectToWhatsApp() {
    //   window.open("https://wa.me/918750272278?text=Hi", "_blank");
    // },
    sendInvite() {
      const agencyId = this.agencyData?.agency_profile_id || '-';
      // const message = `*Agency invatation ID  :*\nhttps://play.google.com/store/apps/details?id=com.care.pro&pcampaignid=web_share`;
      const message =
        `*Agency Invitation ID :* ${agencyId}\n` +
        `https://play.google.com/store/apps/details?id=com.care.pro&pcampaignid=web_share`;

      if (window.WhatsAppBridge?.invite) {
        window.WhatsAppBridge.invite(message);
      } else {
        // fallback for browsers
        window.open(
          "https://api.whatsapp.com/send?text=" + encodeURIComponent(message),
          "_blank"
        );
      }
    },

    // Accepts "token=<jwt>" or "<jwt>"
    normalizeToken(input) {
      if (!input || typeof input !== 'string') return '';
      return input.startsWith('token=') ? input.slice(6) : input;
    },

    money(val) {
      const num = Number(val);
      return Number.isFinite(num) ? num.toFixed(2) : '0.00';
    },

    async fetchDateRangesAndThenAgencyData() {
      this.loading = true;
      try {
        const { data } = await api.get('getweeklistfromagency');
        if (data?.success && Array.isArray(data.result) && data.result.length > 0) {
          this.dateRanges = data.result;

          const firstRange = this.dateRanges[0];
          this.startDate = firstRange.start_date;
          this.endDate = firstRange.end_date;
          this.selectedWeek = firstRange.week_data;

          await this.fetchAgencyData(false);
        } else {
          console.error('No valid week data received.');
        }
      } catch (err) {
        console.error('Failed to fetch weekly date ranges:', err);
      } finally {
        this.loading = false;
      }
    },

    async fetchAgencyData(manageLoading = true) {
      if (manageLoading) this.loading = true;
      try {
        // NOTE: No userid param — API uses token to resolve user
        const { data } = await api.get('agencycenterfromagency', {
          params: {
            start_date: this.startDate,
            end_date: this.endDate
          }
        });
        this.agencyData = data?.result?.agency_data || {};
        this.agencyHostData = data?.result?.data || [];
      } catch (err) {
        console.error('Failed to fetch agency data:', err);
      } finally {
        if (manageLoading) this.loading = false;
      }
    },

    async openDateModal() {
      await this.fetchDateRanges(); // refresh ranges under auth
      this.showModal = true;
    },

    async fetchDateRanges() {
      try {
        const { data } = await api.get('getweeklistfromagency');
        if (data?.success && Array.isArray(data.result)) {
          this.dateRanges = data.result;
        }
      } catch (err) {
        console.error('Failed to fetch weekly date ranges:', err);
      }
    },

    async selectDate(range) {
      this.selectedWeek = range.week_data;
      this.startDate = range.start_date;
      this.endDate = range.end_date;
      this.showModal = false;
      await this.fetchAgencyData();
    },

    closeModal() {
      this.showModal = false;
    },

    goToAgencyTeamList() {
      //   this.$router.push('/agency-team-list/token=:token');
      const jwt = this.authToken || this.$route.params.token || this.$route.query.token || '';
      const normalized = jwt.startsWith('token=') ? jwt.slice(6) : jwt;
      this.$router.push(`/agency-team-list/token=${encodeURIComponent(normalized)}`);
    },

    goToTeamIncomeOverview(userId) {
      //   this.$router.push(`/transaction-history?userid=${userId}&start_date=${this.startDate}&end_date=${this.endDate}`);
      const raw = this.authToken || this.$route.params.token || this.$route.query.token || '';
      const token = this.normalizeToken(raw);

      const q = new URLSearchParams({
        userid: String(userId),
        start_date: this.startDate,
        end_date: this.endDate,
        token // carry the JWT to the next page
      }).toString();

      this.$router.push(`/transaction-history?${q}`);
    },

    copyAgencyId() {
      const idToCopy = this.agencyData?.agency_profile_id;
      if (!idToCopy) return;

      const copySuccess = () => {
        this.showCopyPopup = true;
        setTimeout(() => { this.showCopyPopup = false; }, 2000);
      };

      if (navigator?.clipboard?.writeText) {
        navigator.clipboard.writeText(String(idToCopy))
          .then(copySuccess)
          .catch((err) => {
            console.error('Clipboard API failed:', err);
            this.fallbackCopyText(String(idToCopy), copySuccess);
          });
      } else {
        this.fallbackCopyText(String(idToCopy), copySuccess);
      }
    },

    fallbackCopyText(text, onSuccess) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try { if (document.execCommand('copy')) onSuccess(); }
      catch (err) { console.error('Fallback copy failed:', err); }

      document.body.removeChild(textarea);
    },

    onImageError(event) {
      event.target.src = this.defaultProfile;
    },

    viewClose(status) {
      if (window.Android && typeof Android.viewClose === "function") {
        Android.viewClose(status);
      } else {
        window.parent.postMessage({ action: "closePopup", status }, "*");
      }
    }
  }
};
</script>
